"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _formatDateRange = _interopRequireDefault(require("../../../../../utils/formatDateRange"));
var _preview = _interopRequireDefault(require("../../shared-components/application-list/preview"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class CopyApplication extends _react.Component {
  render() {
    const applications = this.props.applications;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, "Click on a competition from last year to copy to this year (but to start on", ' ', (0, _occasion.default)(this.props.calendarDateID, 'D MMMM'), ") or click \"Next\" to setup from scratch")), applications.map(application => /*#__PURE__*/_react.default.createElement(_button.default, {
      key: application.id,
      style: {
        marginTop: 12
      },
      block: true,
      onClick: () => this.props.onSelectApplication(application.id)
    }, /*#__PURE__*/_react.default.createElement("div", {
      key: application.id,
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header text-xs-center",
      style: {
        color: 'white',
        backgroundColor: 'gray'
      }
    }, (0, _formatDateRange.default)(application.competitionDates)), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_preview.default, {
      application: application
    }))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CopyApplication, "partialQueries", {
  Application: _mergeBqlQueries({
    id: true,
    competitionDates: true
  }, _preview.default.partialQueries.Application)
});
var _default = exports.default = CopyApplication;